
import { Component, Vue } from "vue-property-decorator";
import {
  getGoodsListByBarcode,
  GoodsListOfCategoryDto,
  GoodsListOfCategoryFormatDto,
  SelectGoodsOptionsDto
} from "@/api/commonConfig";
import { Action, Getter } from "vuex-class";
import BuyCarDialog from "@/views/orderManage/template/BuyCarDialog.vue";
import BuyCarPop from "@/views/orderManage/template/BuyCarPop.vue";
import ChooseGoodsCard from "@/views/orderManage/template/ChooseGoodsCard.vue";
import math from "@/core/math";
import { backToBefore } from '@/utils/h5ToApp'

@Component({
  name: "BarCodeGoodList",
  components: { ChooseGoodsCard, BuyCarDialog, BuyCarPop }
})
export default class BarCodeGoodList extends Vue {
  @Getter companyId!: string;
  @Getter selectList!: SelectGoodsOptionsDto[];
  @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void;

  params = {
    companyId: "",
    customerId: "",
    barcode: "",
    pageIndex: 1,
    pageSize: 20
  };
  refreshing = false;
  loading = false;
  finished = false;

  shopGoodsList: GoodsListOfCategoryDto[] = [];
  goodsList: GoodsListOfCategoryFormatDto[] = [];
  selectGoodsList: SelectGoodsOptionsDto[] = [];

  created() {
    this.params.companyId = this.companyId;
    this.params.customerId = this.$route.query.customerId as string;
    this.params.barcode = this.$route.query.barcode as string;
    this.params.customerId = this.$route.query.customerId as string;
    this.selectGoodsList = JSON.parse(JSON.stringify(this.selectList));
    this.getList();
  }

  get totalPrice() {
    let amountMoney = 0;
    if (this.selectGoodsList && this.selectGoodsList.length > 0) {
      this.selectGoodsList.forEach((item) => {
        if (item.orderPrice) {
          amountMoney = Number(
            math.mathAdd(
              amountMoney,
              math.mathMultiply(item.orderPrice, item.saleAmount || 0)
            )
          );
        }
      });
    }
    return amountMoney;
  }

  /**
   * js调用原生api跳转二维码获取新的条形码数据
   */
  getQRCode() {
    this.$bridge.callHandler("toQRCodePage", {}, (res: string) => {
      this.params.barcode = res;
      this.params.pageIndex = 1;
      this.getList();
    });
  }

  getList() {
    getGoodsListByBarcode(this.params)
      .then((res) => {
        this.refreshing = false;
        this.shopGoodsList = res.data.records || [];
        if (this.shopGoodsList && this.shopGoodsList.length > 0) {
          this.initGoodsList();
        } else {
          this.$toast("商品不存在或已下架");
        }
        if (this.shopGoodsList.length >= res.data.totalRecords) {
          this.finished = true;
        }
      })
      .catch(() => {
        this.refreshing = false;
      });
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    this.getList();
  }

  /**
   * 上拉加载更多
   * */
  onLoad() {
    this.params.pageIndex++;
    this.loading = true;
    getGoodsListByBarcode(this.params)
      .then((res) => {
        this.loading = false;
        this.shopGoodsList = this.shopGoodsList.concat(res.data.records);
        this.initGoodsList();
        if (this.shopGoodsList.length >= res.data.totalRecords) {
          this.finished = true;
        }
      })
      .catch(() => {
        this.loading = false;
      });
  }

  initGoodsList() {
    this.goodsList = this.shopGoodsList.map((item) => {
      return {
        goodsId: item.goodsId,
        goodsName: item.goodsName,
        imageNameUrl: item.imageNameUrl,
        versionId: item.versionId,
        // @ts-ignore
        saleAmount: item.packageList[0].minimum || 1,
        orderPrice: item.packageList[0].orderPrice,
        packageId: item.packageList[0].packageId,
        packageName: item.packageList[0].packageName,
        packageNameDesc: item.packageList[0].packageNameDesc,
        minimum: item.packageList[0].minimum,
        maximum: item.packageList[0].maximum
      };
    });
  }

  showBuyCar() {
    if (!this.selectGoodsList || this.selectGoodsList.length <= 0) {
      return this.$toast("请先选择商品");
    }
    (this.$refs.buyCarPop as any).show({
      data: this.selectGoodsList
    });
  }

  sureFunc() {
    if (this.selectGoodsList && this.selectGoodsList.length > 0) {
      this.setSelectList(this.selectGoodsList);
      // 先去掉两条历史记录，再做页面跳转
      this.$router.go(-2);
      const path = window.sessionStorage.getItem("toPath");
      this.$router.replace({
        path: path,
        query: {
          fromPath: "2",
          totalPrice: String(this.totalPrice)
        }
      });
    } else {
      return this.$toast("请先选择商品");
    }
  }

  changeClass(type: string) {
    if (type === "1") {
      (this.$refs.search as any).classList.add("focus");
    } else if (type === "2") {
      (this.$refs.search as any).classList.remove("focus");
    }
  }

  /* 添加商品到购物车 */
  addFunc(data, index) {
    (this.$refs.buyCarDialog as any).show({
      customerId: this.params.customerId,
      shopId: this.companyId,
      goodsName: this.goodsList[index].goodsName,
      data: data,
      selectGoodsList: this.selectGoodsList
    });
  }

  /* 获取选择的套餐信息 */
  getPackageData(data: SelectGoodsOptionsDto) {
    const list = this.selectGoodsList;
    if (this.selectGoodsList && this.selectGoodsList.length > 0) {
      const existIndex = this.selectGoodsList.findIndex(
        (item) => item.packageId === data.packageId
      );
      if (existIndex !== -1) {
        data.saleAmount += 1;
        list.splice(existIndex, 1, data);
      } else {
        data.saleAmount = data.minimum || 1;
        list.push(data);
      }
    } else {
      data.saleAmount = data.minimum || 1;
      list.push(data);
    }
    console.log(this.selectGoodsList)
    this.setSelectList(this.selectGoodsList);
    this.selectGoodsList = JSON.parse(JSON.stringify(list));
  }
}
